export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const strongPasswordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{8,}$/;
export const strongPasswordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/;
export const namePattern = /^[A-Za-zÁáÉéÍíÓóÚúÑñÜüÇç\s]+$/u;
export const phoneNumberPattern = /^\d{10}$/;
